export const HEADER = "lobbyHeader";
